<template>
  <div
    v-if="$store.state.currentUser.isAdmin"
    class="settings">
    <div class="header">
      <div
        class="toggle-show-menu material-icons"
        @click="isShowMenu = !isShowMenu">menu</div>
      <div class="title">設定</div>
    </div>
    <Menu v-if="isShowMenu" />
    <router-view />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import Menu from '@/components/modules/Settings/Menu'
import sw from '@/utils/sweetAlert'

export default {
  components: {
    Menu
  },
  data () {
    return {
      /**
       * メニューエリア表示中かを判別するフラグ
       * @type {Boolean}
       */
      isShowMenu: true
    }
  },
  async beforeCreate () {
    document.title = '日報管理アプリ - 設定'
    this.$store.commit('setTenant', firebase.auth().currentUser.email.split('@')[1])
    await this.$store.dispatch('initializeUser')
    if (!this.$store.state.currentUser.isAdmin) {
      sw.infoAlert('管理者アカウントでサインインしてください')
      return
    }
  }
}
</script>

<style scoped>
.settings {
  position: fixed;
  width: 100%;
  min-width: 800px;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  user-select: none;
  background:#fff;
}
#loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.header {
  position: relative;
  user-select: none;
  display: flex;
  background: #fff;
  width: 100%;
  height: 48px;
  min-height: 48px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, .25);
  z-index: 6;
}
.toggle-show-menu {
  height: 100%;
  margin: 0 0 0 10px;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
}
.title {
  height: 100%;
  margin: 0 0 0 10px;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings.vue